import React, { useState } from 'react';
import FontAwesome from "../uiStyle/FontAwesome";

const SearchModal = ({ searchShow, setSearchShow }) => {
    //TODO search - montar aqui
    const [search, setSearch] = useState('');
    const submitHandler = e => {
        e.preventDefault();
        setSearch('')
    };

    return (
        <div className="searching active" style={{ backgroundColor: "black", opacity: "0.85" }}>
            <div className="container">
                <div className="row">
                    <div className="col-8 text-center m-auto">
                        <div className="v1search_form" style={{ backgroundColor: "black", opacity: "1" }} >
                            <form onSubmit={submitHandler}>
                                <input value={search} onChange={(e) => setSearch(e.target.value)} type="search"
                                    placeholder="Pesquise Aqui..." />
                                <button type="submit" className="cbtn1">Buscar</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="close_btn" onClick={() => setSearchShow(false)}><FontAwesome name="times" /></div>
        </div>
    );
};

export default SearchModal;